import { render } from "./ReportEmployeeEmissions.vue?vue&type=template&id=8b5f2b0a"
import script from "./ReportEmployeeEmissions.vue?vue&type=script&lang=js"
export * from "./ReportEmployeeEmissions.vue?vue&type=script&lang=js"

import "./ReportEmployeeEmissions.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__